import { CONNECTION_STATES, type AqsiDeviceConnection, type ConnectionState } from '../model/connection'
import { fail, objectOf, optionalText, textOf } from './wire'

/**
 * Связь кассы (FIX-C3) — поле `connection` касс, мест и снимка касс. Поле
 * аддитивное: служба прежней версии его не отдаёт — тогда `null`, а не ошибка.
 */
export function decodeConnection(raw: unknown, field: string): AqsiDeviceConnection | null {
  if (raw === null || raw === undefined) return null
  const item = objectOf(raw, field)
  const state = textOf(item.state, `${field}.state`)
  if (!(CONNECTION_STATES as readonly string[]).includes(state)) fail(`${field}.state: неизвестное значение ${state}`)
  return {
    state: state as ConnectionState,
    title: textOf(item.title, `${field}.title`),
    message: textOf(item.message, `${field}.message`),
    lastContactAt: optionalText(item.lastContactAt, `${field}.lastContactAt`),
    noAnswerSince: optionalText(item.noAnswerSince, `${field}.noAnswerSince`),
    cabinetUnavailableAt: optionalText(item.cabinetUnavailableAt, `${field}.cabinetUnavailableAt`),
  }
}
